import React from "react";

const Features = () => {
  return (
    <>
      <div className="features" id="features">
        <div className="wrapper">
          <div className="heading content">
            <div
              className="sub-title"
              data-reveal="bottom"
              style={{
                translate: "none",
                rotate: "none",
                scale: "none",
                transform: "translate(0px)",
                opacity: "1",
                visibility: "inherit",
              }}
            >
              Our features
            </div>
            <h2
              className="h1"
              data-reveal="bottom"
              style={{
                translate: "none",
                rotate: "none",
                scale: "none",
                transform: "translate(0px)",
                opacity: "1",
                visibility: "inherit",
              }}
            >
              <small>
                Explore all the <strong>features</strong>
              </small>{" "}
              of AI Flow
            </h2>
            <div className="point"></div>
            <div className="lazyload-wrapper ">
              <picture>
                <img
                  src="/assets/bg-features-zDR0h0gW.png"
                  width="1235"
                  height="937"
                  alt="Home"
                  draggable="false"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
          <div className="list">
            <div className="feature" style={{ "--color": "var(--pink)" }}>
              <div className="feature-left">
                <div
                  className="number"
                  data-reveal="top"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  1
                </div>
                <hr />
                <div
                  className="icon"
                  data-reveal="top"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 41"
                    fill="currentColor"
                    stroke="none"
                  >
                    <use href="/assets/sprites-JdJ7Xybh.svg#chat"></use>
                  </svg>
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </div>
                <h3
                  className="color"
                  data-reveal="bottom"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  AI Chat Builder
                </h3>
                <div
                  className="p"
                  data-reveal="bottom"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  We are bringing to you the most powerful conversational systems - using the latest
                  AI models. You can create and customize your own chatbots with ease,
                  enabling your users to get the answers they need, when they need them.
                </div>
              </div>
              <div
                className="feature-right"
                data-reveal="true"
                style={{
                  translate: "none",
                  rotate: "none",
                  scale: "none",
                  transform: "translate(0px)",
                  opacity: "1",
                  visibility: "inherit",
                }}
              >
                <div style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -40px)"}}>
                  <div className="lazyload-wrapper ">
                    <picture>
                      <img
                        src="/assets/ai-chat-bhwzdnKs.png"
                        width="736"
                        height="421"
                        alt="AiFlow"
                        draggable="false"
                        loading="lazy"
                      />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="point"></div>
              <div className="corner" data-colors="tertiary">
                <span className="corner-left"></span>
                <span className="corner-right"></span>
                <span className="corner-top-bottom"></span>
              </div>
            </div>
            <div className="feature" style={{"--color": "var(--yellow)"}}>
              <div className="feature-left">
                <div
                  className="number"
                  data-reveal="top"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  2
                </div>
                <hr />
                <div
                  className="icon"
                  data-reveal="top"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 41"
                    fill="currentColor"
                    stroke="none"
                  >
                    <use href="/assets/sprites-JdJ7Xybh.svg#list"></use>
                  </svg>
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </div>
                <h3
                  className="color"
                  data-reveal="bottom"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  Process Automation
                </h3>
                <div
                  className="p"
                  data-reveal="bottom"
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate(0px)",
                    opacity: "1",
                    visibility: "inherit",
                  }}
                >
                  Streamline your application process with our AI-driven drag and drop workflow builder,
                  making your application flow easier and efficient.
                  enabling your clients to efficiently identify and focus on those most
                  worthy of your attention. 
                </div>
              </div>
              <div
                className="feature-right"
                data-reveal="true"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
              >
                <div style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -40px)"}}>
                  <div className="lazyload-wrapper ">
                    <picture>
                      <img
                        src="/assets/ai-ranked-pw7W9IHN.png"
                        width="761"
                        height="421"
                        alt="AI Rankings"
                        draggable="false"
                        loading="lazy"
                      />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="point"></div>
              <div className="corner" data-colors="tertiary">
                <span className="corner-left"></span>
                <span className="corner-right"></span>
                <span className="corner-top-bottom"></span>
              </div>
            </div>
            <div className="feature" style={{"--color": "var(--blue)"}}>
              <div className="feature-left">
                <div
                  className="number"
                  data-reveal="top"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  3
                </div>
                <hr />
                <div
                  className="icon"
                  data-reveal="top"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 41"
                    fill="currentColor"
                    stroke="none"
                  >
                    <use href="/assets/sprites-JdJ7Xybh.svg#stars"></use>
                  </svg>
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </div>
                <h3
                  className="color"
                  data-reveal="bottom"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  AI Analysis
                </h3>
                <div
                  className="p"
                  data-reveal="bottom"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  Start your own analysis by entering the URL of a
                  crypto-project website, and quickly obtain a comprehensive
                  overview and actionable insights in no time: you'll never need
                  more than 5 minutes to understand a project's essentials
                  again.
                </div>
              </div>
              <div
                className="feature-right"
                data-reveal="true"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
              >
                <div style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -40px)"}}>
                  <div className="lazyload-wrapper ">
                    <picture>
                      <img
                        src="/assets/ai-analysis-j9Z6eIQb.png"
                        width="761"
                        height="407"
                        alt="AI Analysis"
                        draggable="false"
                        loading="lazy"
                      />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="point"></div>
              <div className="corner" data-colors="tertiary">
                <span className="corner-left"></span>
                <span className="corner-right"></span>
                <span className="corner-top-bottom"></span>
              </div>
            </div>
            <div className="feature" style={{ "--color": "var(--orange)" }}>
              <div className="feature-left">
                <div
                  className="number"
                  data-reveal="top"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  4
                </div>
                <hr />
                <div
                  className="icon"
                  data-reveal="top"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 41"
                    fill="currentColor"
                    stroke="none"
                  >
                    <use href="/assets/sprites-JdJ7Xybh.svg#fire"></use>
                  </svg>
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </div>
                <h3
                  className="color"
                  data-reveal="bottom"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  Sustainable Model
                </h3>
                <div
                  className="p"
                  data-reveal="bottom"
                  style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
                >
                  Unlock our premium features by staking or burning the $GEMAI
                  token, enabling access to exclusive benefits. This approach
                  not only supports a sustainable model but also contributes to
                  making our token deflationary over time, assisting in covering
                  AI operational costs.
                </div>
              </div>
              <div
                className="feature-right"
                data-reveal="true"
                style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
              >
                <div style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -40px)"}}>
                  <div className="lazyload-wrapper ">
                    <picture>
                      <img
                        src="/assets/staking-burn-nXHbyl-z.png"
                        width="761"
                        height="421"
                        alt="Sustainable Model"
                        draggable="false"
                        loading="lazy"
                      />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="point"></div>
              <div className="corner" data-colors="tertiary">
                <span className="corner-left"></span>
                <span className="corner-right"></span>
                <span className="corner-top-bottom"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
